import React, { type JSX } from "react";

// TODO(paul, Q3): Dynamically generate eslint exceptions from this list.
export const chunkTransformations = {
  // NOTE: we're explicitly setting `font-weight: var(--font-weight-medium)` here instead of using `.font-medium` TW class because these chunk transforms may be used in projects where TW isn't configured (ie. emails)
  Medium: (chunks: JSX.Element) => (
    <span style={{ fontWeight: "var(--font-weight-medium)" }}>{chunks}</span>
  ),
  /**
   * @deprecated bold font-weight is baked into specific typography variants (use those directly), if you need "bolded" text use `chunkTransformations.Medium`
   */
  BoldDeprecated: (chunks: JSX.Element) => (
    <span style={{ fontWeight: "var(--font-weight-medium)" }}>{chunks}</span>
  ),
  /**
   * @deprecated use `chunkTransformations.Medium` instead
   */
  b: (chunks: JSX.Element) => <b>{chunks}</b>,
  u: (chunks: JSX.Element) => <u>{chunks}</u>,
  i: (chunks: JSX.Element) => <i>{chunks}</i>,
  nbsp: "\xa0",
  /**
   * @deprecated use `chunkTransformations.Medium` instead
   */
  strong: (chunks: JSX.Element) => <strong>{chunks}</strong>,
  lineBreak: <br />,
} as const;

export type ChunkTransformationKey = keyof typeof chunkTransformations;
